import React from "react";
import MultiSelectRefinementList from "components/search/base/MultiSelectRefinementList";
import { authorEthnicities } from "components/search/references/authorCategories";

const AuthorEthnicityMultiSelect = () => {
  return (
    <MultiSelectRefinementList
      attribute="authorEthnicity"
      categories={authorEthnicities}
      className="refinement-list__author-ethnicity"
      id="refinement-list__author-ethnicity"
      limit={100}
      name="refinement-list__author-ethnicity"
      title="Ethnicity"
    />
  );
};

export default AuthorEthnicityMultiSelect;
